import type { TModulesNames } from 'app/types';
import { constants, getFromLocalStorage } from './localStorage';

const checkIsAuthorizedAction = (moduleName: TModulesNames): boolean => {
  const modules = getFromLocalStorage(constants.AUTHORIZED_MODULES);
  const user = getFromLocalStorage(constants.user);

  if (
    moduleName === 'DASHBOARD' ||
    (moduleName === 'SETTINGS' && user?.site_admin) ||
    !isNaN(+moduleName)
  )
    return true;
  return modules?.some((item: TModulesNames) => item === moduleName);
};
export { checkIsAuthorizedAction };
